export enum BONUS_AMOUNT_TYPES {
    FREE_SPINS = 'freespins',
    FREE_SPINS2 = 'freespins2',
    GOLDEN_CHIPS = 'goldenchips',
    PREWAGER = 'prewager'
}
